import { VStack, Heading, Text, Box, HStack } from '@chakra-ui/react'
import { Globe } from 'lucide-react'

export function ExtranetPage() {
  return (
    <VStack align="stretch" gap={6}>
      {/* Header */}
      <VStack align="start" gap={2}>
        <HStack gap={2}>
          <Globe size={24} />
          <Heading as="h2" fontSize="2xl">
            Extranet
          </Heading>
        </HStack>
        <Text color="gray.600">
          Configuration du portail copropriétaires
        </Text>
      </VStack>

      {/* Coming Soon */}
      <Box
        p={12}
        bg="gray.50"
        borderRadius="lg"
        border="1px dashed"
        borderColor="gray.300"
        textAlign="center"
      >
        <VStack gap={3}>
          <Globe size={48} color="#9ca3af" />
          <VStack gap={2}>
            <Heading fontSize="lg" color="gray.700">
              Bientôt disponible
            </Heading>
            <Text color="gray.600" fontSize="sm">
              Personnalisation de l'extranet : sous-domaine, couleurs, logo, modules activés, etc.
            </Text>
          </VStack>
        </VStack>
      </Box>
    </VStack>
  )
}
